import React from 'react';
import { Link } from 'react-router-dom';

import './Sidebar.scss';

import Icon from 'Core/Components/Icon';

class Sidebar extends React.Component {
  constructor (props) {
    super(props);
    this.renderMenu = this.renderMenu.bind(this);
    this.renderMenuItem = this.renderMenuItem.bind(this);
  }

  renderMenuItem (item, index) {
    if (item.divider) return <hr />;
    const { text, icon, url, onClick, className, target } = item;

    const children = (
      <React.Fragment>
        {typeof text !== 'string'
          ? text
          : <span>{text}</span>
        }
        {!icon ? null : <Icon fa={icon}/>}
      </React.Fragment>
    );

    const active = window.location.pathname === url;
    const props = {
      onClick,
      target,
      children,
      className: (className ? className : '')
        + (active ? ' active' : '')
    };

    return url
      ? <Link {...props} className={(active ? 'active' : '') + (className ? ' ' + className : '')} to={url} />
      : onClick
        ? <a {...props} />
        : <em>{children}</em>
  }

  renderMenu ({ items = [] } = {}) {
    const MenuItem = this.renderMenuItem;
    return (
      <div className="Sidebar-Menu">
        {items.map((props, index) => <MenuItem key={index} {...props} />)}
      </div>
    );
  }

  render () {
    const { children, menus } = this.props;
    const SidebarMenu = this.renderMenu;

    return (
      <aside className="Sidebar">
        {!children ? null : <div className="Sidebar-Content">{children}</div>}
        <SidebarMenu items={menus} />
      </aside>
    );
  }
};

export default Sidebar;



// WEBPACK FOOTER //
// ./client/RLX/Views/Dashboard/Sidebar/Sidebar.jsx